import axios from 'axios';

// Create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3007',
  timeout: 10000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  async (config) => {
    // 1. Check Firebase currentUser first (most reliable)
    try {
      const { getAuth } = require('firebase/auth');
      const firebaseAuth = getAuth();
      if (firebaseAuth?.currentUser) {
        const token = await firebaseAuth.currentUser.getIdToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
          return config;
        }
      }
    } catch (err) {
      // Firebase not initialized or in test mode – ignore
    }

    // 2. Fallback to test-mode token stored in localStorage
    const userStr = localStorage.getItem('auxbox-user');
    if (userStr) {
      try {
        const user = JSON.parse(userStr);
        if (user.uid && user.uid.startsWith('test-')) {
          const payload = {
            uid: user.uid,
            displayName: user.displayName,
            isGuest: user.isGuest,
            iat: Math.floor(Date.now() / 1000),
            exp: Math.floor(Date.now() / 1000) + 3600,
          };
          config.headers.Authorization = `Bearer ${btoa(JSON.stringify(payload))}`;
        }
      } catch (e) {
        console.error('Error parsing user from localStorage:', e);
        localStorage.removeItem('auxbox-user');
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      console.warn('[API] 401 Unauthorized – clearing auth state');
      localStorage.removeItem('auxbox-user');

      // Attempt to sign out of Firebase (if initialized)
      try {
        const { getAuth, signOut } = require('firebase/auth');
        const fbAuth = getAuth();
        if (fbAuth?.currentUser) {
          await signOut(fbAuth);
        }
      } catch (err) {
        // Ignore if Firebase not in use
      }

      // Prevent redirect loop: only redirect if not already on login page
      if (!window.location.pathname.startsWith('/login')) {
        setTimeout(() => {
          window.location.href = '/login';
        }, 100);
      }
    }

    return Promise.reject(error);
  }
);

export default api; 